export const linkedServiceReferenceWithoutParameterizationRemainer = {
    referenceName: '*',
    type: '*'
};
